import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.urlValue) {
      this.load()
    }
  }

  async load() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      })

      if (response.ok) {
        const turboStreamText = await response.text()

        // This will manually process and render the Turbo Stream response
        Turbo.renderStreamMessage(turboStreamText)
      }
    } catch (error) {
      console.error("Error loading Turbo Stream:", error)
    }
  }
}
